import { stateOptions } from '../commonStateTaxData';

const countyOptions = [
  'not applicable',
  'Adams',
  'Allen',
  'Bartholomew',
  'Benton',
  'Blackford',
  'Boone',
  'Brown',
  'Carroll',
  'Cass',
  'Clark',
  'Clay',
  'Clinton',
  'Crawford',
  'Daviess',
  'DeKalb',
  'Dearborn',
  'Decatur',
  'Delaware',
  'Dubois',
  'Elkhart',
  'Fayette',
  'Floyd',
  'Fountain',
  'Franklin',
  'Fulton',
  'Gibson',
  'Grant',
  'Greene',
  'Hamilton',
  'Hancock',
  'Harrison',
  'Hendricks',
  'Henry',
  'Howard',
  'Huntington',
  'Jackson',
  'Jasper',
  'Jay',
  'Jefferson',
  'Jennings',
  'Johnson',
  'Knox',
  'Kosciusko',
  'LaGrange',
  'LaPorte',
  'Lake',
  'Lawrence',
  'Madison',
  'Marion',
  'Marshall',
  'Martin',
  'Miami',
  'Monroe',
  'Montgomery',
  'Morgan',
  'Newton',
  'Noble',
  'Ohio',
  'Orange',
  'Owen',
  'Parke',
  'Perry',
  'Pike',
  'Porter',
  'Posey',
  'Pulaski',
  'Putnam',
  'Randolph',
  'Ripley',
  'Rush',
  'Scott',
  'Shelby',
  'Spencer',
  'St. Joseph',
  'Starke',
  'Steuben',
  'Sullivan',
  'Switzerland',
  'Tippecanoe',
  'Tipton',
  'Union',
  'Vanderburgh',
  'Vermillion',
  'Vigo',
  'Wabash',
  'Warren',
  'Warrick',
  'Washington',
  'Wayne',
  'Wells',
  'White',
  'Whitley',
];

export const basicInfoQuestions = [
  {
    id: 'employee_name',
    title: 'Full name',
    question_type: 'short_text',
    is_required: true,
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'residence_county',
    title: 'Indiana county of residence as of January 1',
    is_required: true,
    question_type: 'dropdown',
    options: countyOptions,
  },
  {
    id: 'employment_county',
    title: 'Indiana county of principle employment as of January 1',
    is_required: true,
    question_type: 'dropdown',
    options: countyOptions,
  },
];

export const numberOfDependentsQuestions = [
  {
    id: 'number_of_dependents',
    title:
      'You are allowed one exemption for each dependent. Enter the number of dependents claimed',
    is_required: false,
    placeholder: 0,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d+$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
];

export const additionalWithholdingQuestions9_20 = [
  {
    id: 'additional_dependent_exemptions',
    title:
      'You are entitled to claim an additional exemption for each qualifying dependent',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_state_withholding_amount',
    title:
      'Enter the amount of additional state withholding (if any) you want withheld each pay period',
    placeholder: '$',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_county_withholding_amount',
    title:
      'Enter the amount of additional county withholding (if any) you want withheld each pay period',
    placeholder: '$',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const additionalWithholdingQuestions9_22 = (() => {
  const copy = [...additionalWithholdingQuestions9_20];

  copy.splice(1, 0, {
    id: 'additional_adopted_dependent_exemptions',
    title:
      'You are entitled to claim an additional exemption for each adopted qualifying dependent',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  });

  return copy;
})();

export const additionalWithholdingQuestions8_23 = (() => {
  const copy = [...additionalWithholdingQuestions9_22];

  copy.splice(1, 0, {
    id: 'additional_dependent_exemptions_first_time',
    title:
      'You are entitled to claim an additional exemption for each qualifying dependent claimed for the first time',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  });

  return copy;
})();
